import { jsx } from 'react/jsx-runtime';
import { useMemo, createContext, useContext } from 'react';

/**
 * Create Context.
 */ const Context = /*#__PURE__*/ createContext({
    loading: false,
    locale: {
        unread: 'Unread Notification: View Details',
        read: 'Read Notification: View Details'
    }
});
/**
 * Notification List Provider.
 */ const NotificationListProvider = ({ loading = false, locale, children })=>{
    /**
     * Memoize Provider Value.
     */ const value = useMemo(()=>({
            loading,
            locale
        }), [
        loading,
        locale
    ]);
    return jsx(Context.Provider, {
        value: value,
        children: children
    });
};
/**
 * Notification List context hook.
 */ const useNotificationListProviderContext = ()=>{
    return useContext(Context);
};

export { NotificationListProvider, useNotificationListProviderContext };
//# sourceMappingURL=NotificationList.Context.es.js.map
